import { CrossRootSharedContexts } from 'models/CrossRootSharedContexts';

class NodeContextBridge {
    private contexts: CrossRootSharedContexts | null = null;
    private subscribers = new Set<(contexts: CrossRootSharedContexts) => void>();

    setContexts(contexts: CrossRootSharedContexts): void {
        this.contexts = contexts;
        this.subscribers.forEach(callback => callback(contexts));
    }

    getContexts(): CrossRootSharedContexts | null {
        return this.contexts;
    }

    subscribe(callback: (contexts: CrossRootSharedContexts) => void): () => void {
        this.subscribers.add(callback);
        if (this.contexts) {
            callback(this.contexts);
        }

        return () => {
            this.subscribers.delete(callback);
        };
    }
}

export const nodeContextBridge = new NodeContextBridge();